module.exports = __webpack_public_path__ + "img/finish-icon.7c7eb7af.png";